import axios from 'axios';
import { toast } from 'react-toastify';
import {
  EVENTS_DELETE_EVENT_BEGIN,
  EVENTS_DELETE_EVENT_SUCCESS,
  EVENTS_DELETE_EVENT_FAILURE,
  EVENTS_DELETE_EVENT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteEvent(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EVENTS_DELETE_EVENT_BEGIN,
    });
    const { projectId, uuid, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events/${uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: EVENTS_DELETE_EVENT_SUCCESS,
              data: args.uuid,
            });
            Mixpanel.track('Deleted Event', { uuid: args.uuid });
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: EVENTS_DELETE_EVENT_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete event');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EVENTS_DELETE_EVENT_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delet event');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion failed: ${errMsg}`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteEventError() {
  return {
    type: EVENTS_DELETE_EVENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_DELETE_EVENT_BEGIN:
      return {
        ...state,
        deleteEventPending: true,
        deleteEventError: null,
      };

    case EVENTS_DELETE_EVENT_SUCCESS:
      return {
        ...state,
        deleteEventPending: false,
        deleteEventError: null,
        events: state.events.filter((e) => e.uuid !== action.data),
        showCreateEvent: false,
        selectedEvent: null,
      };

    case EVENTS_DELETE_EVENT_FAILURE:
      return {
        ...state,
        deleteEventPending: false,
        deleteEventError: action.data.error,
      };

    case EVENTS_DELETE_EVENT_DISMISS_ERROR:
      return {
        ...state,
        deleteEventError: null,
      };

    default:
      return state;
  }
}
